// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Gbb5","icon":"styles_icon__3g5hd"};